import createIcon from '../../createIcon';

/**
 * @component @name EMobiledata
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgOVY3SDhWMTdIMTZWMTVIMTBWMTNIMTZWMTFIMTBWOUgxNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EMobiledata = createIcon('EMobiledata', [
  ['path', { d: 'M16 9V7H8V17H16V15H10V13H16V11H10V9H16Z', key: '1oif1w' }],
]);

export default EMobiledata;
